module.exports = {
    home: '/',
    login: {
        entry: '/login',
        forgotPassword: '/forgot-password',
        sso: '/login-sso',
        mfa: '/login/mfa'
    },
    signup: {
        entry: '/signup',
        sso: '/signup-sso',
        verifyEmail: '/signup/verify-email',
        password: '/signup/choose-password',
        terms: '/signup/terms',
        ssoTerms: '/sso/terms',
        profile: '/signup/user-info',
        authenticate: '/signup/authenticate'
    },
    app: {
        loader: '/app/loader',
        verifyPhone: '/app/verify-phone',
        welcome: '/app/welcome'
    }
};
